export const updatedSetsSet = (sets) => {
    return {
        type: "PUSH",
        data: sets
    }
}

export const clearUpdatedSetsSet =  () => {
    return {
        type: "CLEAR_UPDATED_SETS"
    }
}